// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1kXTr","left":"StickyBox_left__lW4jY","right":"StickyBox_right__1f3M3"};